// xReceived staff with no company of their own (the project account): a slim bar and the staff pages only.
// Company staff see the same pages inside the normal shell, under "xReceived staff".
import { Brand } from '@xr/ui';
import { L, isDark, prefs, toggleLang, toggleTheme } from '../lib/prefs';
import { signOut, useApp } from '../lib/session';
import { TestersPage } from '../pages/Testers';
import { Btn, IBtn } from '../ui/kit';

export function StaffOnly() {
  const { session } = useApp();
  return (
    <div className="staff-only">
      <header className="staff-bar">
        <Brand kind="lockup" h={20} />
        <span className="staff-tag">{L('Staff', 'الفريق')}</span>
        <span className="staff-who">{session?.user.email}</span>
        <IBtn icon="globe" title={prefs.get().lang === 'ar' ? 'English' : 'العربية'} onClick={toggleLang} />
        <IBtn icon={isDark() ? 'sun' : 'moon'} title={isDark() ? L('Light theme', 'الوضع الفاتح') : L('Dark theme', 'الوضع الداكن')} onClick={toggleTheme} />
        <Btn kind="ghost" icon="logout" title={L('Sign out', 'تسجيل الخروج')} onClick={() => void signOut()}>{L('Sign out', 'تسجيل الخروج')}</Btn>
      </header>
      <main id="page" className="page" tabIndex={-1}><TestersPage /></main>
    </div>
  );
}
